import { useState } from 'react';
import { and, assoc, both, dec, equals, length, modify, not } from 'ramda';
import useDeleteBeneficiaryMutation from './useDeleteBeneficiaryMutation.js';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';
import { isDisabledAddingBeneficiary } from '@@viewHelpers/beneficiary.js';
import { GranteeTypeEnum } from '@fasstech/oip-core/entities/Grantee/enums';

const useHandleGrantees = ({ setTabs, nbMaxChild, nbMaxSpouse, form, fields, append, remove }) => {
  const [displayDeletionModal, setDisplayDeletionModal] = useState(false);
  const [deletingGrantee, setDeletingGrantee] = useState({
    id: null,
    index: null
  });

  const { onFormSubmit: deleteBeneficiary } = useDeleteBeneficiaryMutation();

  const beneficiaryDefaultValue = {
    type: equals(nbMaxChild, 0)
      ? GranteeTypeEnum.SPOUSE
      : equals(nbMaxSpouse, 0)
        ? GranteeTypeEnum.CHILD
        : '',
    isTNS: false
  };

  const handleRemoveGrantee = async () => {
    const { id, index } = deletingGrantee;

    const hasBeenCreatedInCurrentView = isNilOrEmpty(id);

    const deleteLocally = async () => {
      form.clearErrors(`grantees.${index}`);

      await remove(index);

      setDisplayDeletionModal(false);
      setTabs(modify('selectedTab', dec));
      setDeletingGrantee({
        id: null,
        index: null
      });
      setTimeout(async () => {
        form.clearErrors('grantees');
        await form.trigger();
      }, 150);
    };

    if (hasBeenCreatedInCurrentView) return deleteLocally();

    await deleteBeneficiary({ beneficiaryId: id }, (ok, err) => {
      if (and(ok, not(err))) deleteLocally();
    });
  };

  const isDisabledAddingChild = isDisabledAddingBeneficiary(nbMaxChild, GranteeTypeEnum.CHILD);
  const isDisabledAddingSpouse = isDisabledAddingBeneficiary(nbMaxSpouse, GranteeTypeEnum.SPOUSE);

  const isDisabledAddBeneficiary = both(
    isDisabledAddingSpouse,
    isDisabledAddingChild
  )(form.watch('grantees') || []);

  const handleAddBeneficiary = async () => {
    if (isNilOrEmpty(form.errors)) {
      append(beneficiaryDefaultValue);
      setTabs(assoc('selectedTab', length(fields) + 1));
    } else {
      await form.trigger();
    }
  };

  return {
    handleRemoveGrantee,
    displayDeletionModal,
    setDisplayDeletionModal,
    deletingGrantee,
    setDeletingGrantee,
    isDisabledAddingChild,
    isDisabledAddingSpouse,
    isDisabledAddBeneficiary,
    handleAddBeneficiary
  };
};

export default useHandleGrantees;
